'use strict'
import ReactGA from 'react-ga'
import { ApplicationUtil } from '../../utils/ApplicationUtil'
import ApplicationConf from '../../conf/ApplicationConf'
import { checkAuth } from '../../utils/ActionUtils'
import { LICENCE_KEY } from '../constants/LoginConstants'
import SelectionAction from '../../dashboard/actions/SelectionAction'
import CreditAction from '../../home/actions/CreditAction'
import HomeAction from '../../home/actions/HomeAction'
import i18n from 'simple-react-i18n'
import ToastrAction from '../../home/actions/ToastrAction'

const SignInAction = {
	login: function (login, password, functionToLoad = undefined) {
		return function (dispatch) {
			ReactGA.set({ userId: ApplicationUtil.getUserId(login) })
			const basicAuth = btoa(login + ':' + password)
			return fetch(ApplicationConf.login.login(), {
				method: 'POST',
				headers: {
					Authorization: 'Basic ' + basicAuth,
					Accept: 'application/json'
				},
				body: JSON.stringify({
					licence: btoa(LICENCE_KEY)
				})
			})
				.then(checkAuth)
				.then(() => {
					sessionStorage.setItem('TOKEN', btoa(login))
					dispatch(SelectionAction.fetchSelections(login))
					dispatch(CreditAction.fetchUserInitCredit(login))
					dispatch(HomeAction.updateLoginModalState(false))
					dispatch(HomeAction.fetchUser(login))
				}).then(() => {
					if (functionToLoad && functionToLoad.length) {
						functionToLoad[0]()
					}
				}).catch(() => {
					dispatch(ToastrAction.error(i18n.error.loginError))
				})
		}
	}
}

export default SignInAction



// WEBPACK FOOTER //
// ./src/login/actions/SignInAction.js